export default __webpack_public_path__ + "static/media/hero1.fc904c4c.svg";